import { ChequeGiroModel } from 'api-hooks/cheque-giro';
import * as Yup from 'yup';

export const ChequeGiroFormSchema = () =>
  Yup.object({
    name: Yup.string().default('').required(),
    bankCode: Yup.string().default('').required(),
    isActive: Yup.boolean().default(false),
  });

export type ChequeGiroFormType = {
  name: string;
  bankCode: string;
  isActive: boolean;
  chequeGiro?: ChequeGiroModel;
};
